import { ADD_PHONE_NUMBER } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
export default function addPhoneNumber(addPhoneNumberArguments) {
  return callingAPIMethodWithQueue(ADD_PHONE_NUMBER, addPhoneNumberArguments);
}